import { actionTypes } from "../contants/actionTypes";


const initialState = {
    data: [],
    isLoading: false,
    error: null,
};


export const approvalReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CLEAR_APPROVAL_DATA':
            return {
                ...state,
                data: null,
            };
        case actionTypes.approvalStart:
        case actionTypes.approvalStartByID: 
        case actionTypes.saveApprovalStart:
        case actionTypes.approvalStartUpdate:  
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case actionTypes.approvalFinish:
        case actionTypes.approvalFinishByID:
        case actionTypes.saveApprovalFinish:
        case actionTypes.approvalFinishUpdate:  
            return {
                ...state,
                isLoading: false
            };

        case actionTypes.approvalLoadApproval: 
        case actionTypes.approvalLoadApprovalByID:
        case actionTypes.saveApprovalSuccess:  
        case actionTypes.approvalLoadUpdate:
            return {
                ...state,
                data: action.payload.data,
                error: null
            };

        case actionTypes.approvalError:
        case actionTypes.approvalErrorByID:
        case actionTypes.saveApprovalError: 
        case actionTypes.approvalErrorUpdate: 
            return {
                ...state,
                error: action.payload.error,
                isLoading: false
            };
        default:
            return state;
    }

};